<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <h3 class="mb-3">{{ t('title') }}</h3>
  <form [formGroup]="form">
    <ng-container [formArrayName]="formSectionName">
      <ng-container *ngFor="let room of rooms; let index = index">
        <rx-applications-clientsite-checkout-room
          [formSectionName]="formSectionName"
          [index]="index"
          [defaultValue]="room"
        ></rx-applications-clientsite-checkout-room>
      </ng-container>
    </ng-container>
  </form>
  <rx-alert *ngIf="showLoyaltyAlert$ | async" type="warning" [message]="t('loyaltyAlert')"></rx-alert>
</ng-container>
